const axios = require('axios')
const qs = require('qs')

import getCookie from '@/service/getCookie'
import deleteCookie from '@/service/deleteCookie'
import store from '../desktop/stores'
import { commonMixin } from '../mixins/common'

const axiosFormSubmit = async (url, data = {}, debugMsg = '', option, userId) => {
  if(option == null){   
    let SetOption = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;',
      'x-api-host': 'mycrm',
    }
    option = SetOption
  }
  
  let x_api_key = getCookie('api-keys') ? JSON.parse(getCookie('api-keys'))[0] : '';
  if (x_api_key) {
    option['x-api-key'] = x_api_key
  }
  /*20250808配合滲透測試弱點移除header中x-id
  if (userId) {
    option['x-id'] = userId
  }
  */
  // 判斷如果 url 有 http 就不加動態網域
  let API_BASEURL = ''
  let BFF_API_BASEURL = window.location.origin;
  if(url.indexOf('http') > -1){
    API_BASEURL = ''
  }else{
    API_BASEURL = 'http://localhost:8081/MXWeb'
    if(window.location.href.indexOf('localhost') !== -1){
      API_BASEURL = 'http://localhost:8081/MXWeb'
      BFF_API_BASEURL = `http://localhost:8088`
    }else if(window.location.href.indexOf('tmycrm') !== -1){
      API_BASEURL = 'https://tcrmapi.cathaylife.com.tw/MXWeb'
    }else if(window.location.href.indexOf('smycrm') !== -1){
      API_BASEURL = 'https://scrmapi.cathaylife.com.tw/MXWeb'
    }else if(window.location.href.indexOf('mycrm') !== -1){
      API_BASEURL = 'https://crmapi.cathaylife.com.tw/MXWeb'
    }else{
      // API_BASEURL = 'http://10.87.23.58:8081/MXWeb'
      API_BASEURL = `http://${window.location.href.match(/\d*\.\d*\.\d*\.\d*/g)}:8081/MXWeb`
    }
  }

  let apiUrl = `${API_BASEURL}${url}`
  console.log(`Sent[${debugMsg}],url:${apiUrl}`)
  //判斷BFF路徑
  if(store.getters.IsBFF_MX){ 
    apiUrl = `${BFF_API_BASEURL}/mid-mxf0-crm-ui${commonMixin.methods.convertUri(url)}`
    delete option['x-api-key'];
    if(url.indexOf('/logout') > -1){
      apiUrl = `${BFF_API_BASEURL}/mid-mxf0-crm-ui/logout`;
    }
  }
  
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      // url: `${API_PROXY}${API_BASEURL}${url}`,
      url: apiUrl,
      data: qs.stringify(data),
      // headers: {
      //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;',
      //   'X-Requested-With': 'XMLHttpRequest',
      // },
      headers: option,
      timeout: 60000,
      responseType: 'json',
      withCredentials: true,
    })
    .then(response => {
      console.log(`Got[${debugMsg}]Res:${apiUrl}`)
      console.log(response)
      
      if (apiUrl && apiUrl.indexOf('isLoggedIn') < 0 && apiUrl.indexOf('login') < 0 && apiUrl.indexOf('logout') < 0) {
        if (response.data && response.data.detail && (response.data.detail.loginUrl || response.data.detail.ssoUrl)) {
          localStorage.forcePkmslogout = true;
          deleteCookie('api-keys')
          window.location.reload();
          return;
        }
      }
      
      if (response.status === 200) {
        resolve(response.data);
      } else {
        console.error(response);
        let errorData = {
          header:{
            message: "連線逾時 請重新操作",
            status: "400",
            userDeviceIp: "",
            userId: "",
          },
          body:{},
        }
        resolve(errorData);
      }
    })
    .catch(error => {
      console.error(`Got[${debugMsg}]Res:${apiUrl}`)
      console.error(error);
      // BFF 模式下登出後 302 被 CORS 阻擋，error.response 為 null (Network Error)
      if (store.getters.IsBFF_MX && !error.response && !apiUrl.includes('/logout')) {
        const redirectUrl = error.request && error.request.responseURL;
        if (redirectUrl && redirectUrl !== apiUrl) {
          window.location.href = redirectUrl;
        } else {
          window.location.reload(); // fallback：重新載入觸發登入檢查
        }
        return;
      }
      let errorData = {
        header:{
          message: "連線逾時 請重新操作",
          status: "400",
          userDeviceIp: "",
          userId: "",
        },
        body:{},
      }
      //  server 無回應時導頁至錯誤頁面
      window.location.href = window.location.href.replace(/#.*$/,'') + `#/error`
      resolve(errorData)
      // reject(error);
    })
  })
}

export default axiosFormSubmit;